import { assetCDN } from '~/helper'

/**
 * Exposes the environment-aware assets CDN base as `$assetsCdn` on every
 * component instance, so templates can build asset URLs without importing
 * the helper per file:
 *
 *   <img :src="`${$assetsCdn}/icons/deal.png`" />
 *
 * Resolves to `/assets` (public/assets) in local dev and to
 * `${NUXT_STATIC_CDN}/static/public` in built modes. Script blocks should
 * call assetCDN() from ~/helper directly; SCSS uses the `$assets-cdn`
 * Sass variable injected in nuxt.config.ts.
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.globalProperties.$assetsCdn = assetCDN()
})
